import { Color } from '@opallabs/gem'
import { useTheme } from '@opallabs/hooks'
import { ContextMenu, Icon } from '@opallabs/lapidary'
import { AllowedEvents, TrackEvent } from '@opallabs/quanta'

/*
  Unfortunately we don't have great types yet for moments
  and content coming out of the Redux store for week view.
*/
/* eslint-disable @typescript-eslint/no-explicit-any */
type MomentContextMenuProps = {
  contextMenuCallbacks: {
    changeDaySegment: (momentId: string, newDaySegment: string | null) => void
    deleteContent: (id: string, moment: any) => void
    deleteMoment: (momentId: string, withConfirmation: boolean) => void
    duplicateContent: (
      contentItem: any,
      moment: any,
      pivotName?: string
    ) => void
    duplicateMoment: (momentId: string) => void
    renameContent: (contentId: string, newName: string) => void
    renameMoment: (momentId: string, newName: string) => void
    onAddToBoard: (args: { moment: any; defualtUnschedule: boolean }) => void
    pickMomentCoverAsset: (moment: any) => void
  }

  content: any
  moment: any
  setIsRenamePopoverOpen: (open: boolean) => void
  track: TrackEvent
}
/* eslint-enable @typescript-eslint/no-explicit-any */

export const ContentContextMenu: React.FC<
  React.PropsWithChildren<MomentContextMenuProps>
> = ({
  children,
  contextMenuCallbacks,
  content,
  moment,
  setIsRenamePopoverOpen,
  track,
}) => {
  const theme = useTheme()
  const disableAllOptions = !!content.isSaving || !!moment.isUpdatingContent

  return (
    <ContextMenu.Root>
      <ContextMenu.Trigger>{children}</ContextMenu.Trigger>

      <ContextMenu.Portal>
        <ContextMenu.Content style={{ zIndex: 999 }}>
          <ContextMenu.Label
            css={{
              color: Color[theme].Text.Gray,
              opacity: 1,
              display: 'flex',
              gap: 8,
              alignItems: 'center',
            }}
          >
            <Icon
              ariaHidden
              glyph="content-cutout"
              color={Color[theme].Text.Gray}
              height={16}
              useHypernova={true}
              width={16}
            />
            {content?.name}
          </ContextMenu.Label>
          <ContextMenu.Separator />

          <ContextMenu.Item
            disabled={disableAllOptions}
            onSelect={() => {
              track(AllowedEvents.click, {
                id: content.id,
                contentType: content.service.name,
              })
              setIsRenamePopoverOpen(true)
            }}
          >
            Rename content
          </ContextMenu.Item>

          <ContextMenu.Item
            disabled={disableAllOptions}
            onSelect={() => {
              track(AllowedEvents.click, {
                id: content.id,
                contentType: content.service.name,
              })
              contextMenuCallbacks.duplicateContent(content, moment)
            }}
          >
            Duplicate content
          </ContextMenu.Item>

          <ContextMenu.Separator />

          <ContextMenu.Item
            onSelect={() => {
              track(AllowedEvents.click, {
                id: content.id,
                contentType: content.service.name,
              })
              contextMenuCallbacks.deleteContent(content.id, moment)
            }}
            css={{ color: Color[theme].Text.Warning }}
          >
            Delete Content
          </ContextMenu.Item>
        </ContextMenu.Content>
      </ContextMenu.Portal>
    </ContextMenu.Root>
  )
}
